export default "__VITE_ASSET__55068649__"